export const aaaCustomColorsDark = {
    primary: "#ed7226",
    primaryDark: "#d45c11",
    primaryLight: "#6a4231",
    secondary: "#ffffff",
    error: "#ea4848",
    errorBackground: "#fdeded",
    white: "#ffffff",
    borderColor: "#0F152B",
    fieldBackgroundColor: "#ededed",
    middleGrey: "#B4B8B8",
    dataUploadBorderColor: "#B4B8B8",
    disabledElements: "#d45c11",
    profileGrey: "#c4c4c4",
    headingsDark: "#ffffff",
    body1Dark: "#ffffff",
    body2Dark: "#9B9B9B",
    backgroundLight: "#080D22",
    evidenceBackground: "#3F897C",
    evidenceForeground: "#CFFFF6 ",

    hoverColor: "rgba(255, 255, 255, 0.08)",

    cardYellow: "#312b20",
    cardRed: "#2e1728",

    preferred: "#CE970C",
    confirmed: "#2EA34F",

    sideBarDone: "#ffffff",
    sideBarMissing: "#252F54",
    sideBarCurrent: "#ed7226",

    darkPrimary: "#080D22",
    darkSecondary: "#0F152B",
    darkTertiary: "#252F54",
    darkForeground: "#ffffff",

    robotBorder: "#252F54",
    robotBackground: "#ffffff",
    robotBackgroundWhite: "#ffffff",

    graphicShade1: "#CE970C",
    graphicPrimary: "#FFBB11",
    graphicShade2: "#FFEECA",
    uiuxShade1: "#149FC3",
    uiuxPrimary: "#73DCF6",
    uiuxShade2: "#E4FAFF",
    motionShade1: "#2F8B7D",
    motionPrimary: "#6EEFD6",
    motionShade2: "#D9F9F2",
    operationsShade1: "#A54640",
    operationsPrimary: "#EF766E",
    operationsShade2: "#F5C7C4",
    contentCreationShade1: "#E2F3D0",
    contentCreationPrimary: "#86CB95",
    contentCreationShade2: "#2EA34F",
    apprenticeShade1: "#EDCEBC",
    apprenticePrimary: "#ED7226",
    apprenticeShade2: "#D45C11",
    backendShade1: "#C4D3AE",
    backendPrimary: "#6B7D4F",
    backendShade2: "#49553E",
    fullStackShade1: "#FFDDE3",
    fullStackPrimary: "#FF4D6D",
    fullStackShade2: "#C9184A",
    frontEndShade1: "#CDE7EA",
    frontEndPrimary: "#13828B",
    frontEndShade2: "#0C3B3F",

    pmShade1: "#CC9300",
    pmPrimary: "#FFBE16",
    pmShade2: "#FDF2D7",
    webShade1: "#9F53BF",
    webPrimary: "#BF76DE",
    webShade2: "#EBD6F4",
    qaShade1: "#D45C11",
    qaPrimary: "#ED7226",
    qaShade2: "#EDCEBC",
    trainingShade1: "#C9184A",
    trainingPrimary: "#FF4D6D",
    trainingShade2: "#FFDDE3",
    iOSShade1: "#2582B7",
    iOSPrimary: "#46A5DB",
    iOSShade2: "#CEEDF1",
    androidShade1: "#2EA34F",
    androidPrimary: "#86CB95",
    androidShade2: "#E2F3D0",
    flutterShade1: "#49553E",
    flutterPrimary: "#6B7D4F",
    flutterShade2: "#C4D3AE",
    unsolicitedShade1: "#115555",
    unsolicitedPrimary: "#709999",
    unsolicitedShade2: "#b8cccc"
};
